import type { TOC } from '@ember/component/template-only';

const GoalsRouteTemplate: TOC<object> = <template>{{outlet}}</template>;

export default GoalsRouteTemplate;
